import React from 'react';
import { injectIntl } from 'react-intl';

const PreferedLocaleLabel = ({ language, intl }) => {
  const t = intl.messages.prefered_locales;
  return <div>{t[language]}</div>;
};

export default injectIntl(PreferedLocaleLabel);
